export default __webpack_public_path__ + "static/media/1.82c69ab6.png";